import { render, staticRenderFns } from "./TheChatHeader.vue?vue&type=template&id=25f2538e"
import script from "./TheChatHeader.vue?vue&type=script&lang=js"
export * from "./TheChatHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports